import Blue from '~/core'

new Blue({
  name: 'Scrolly',
  selector: '.scrolly',
  setup(scrolly) {
    const animationID = scrolly.dataset.animation
    if (animationID) {
      const animatedContainer = scrolly.querySelector(`#${animationID}`)
      const lottie = animatedContainer.getLottie()

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              lottie.play()
              return
            }

            lottie.pause()
          })
        },
        {
          threshold: 1,
          rootMargin: '-50px',
        },
      )

      observer.observe(animatedContainer)
    }
  },
})
